export default {
    "ev_session.session_id": "充電紀錄 ID",
    "ev_session.fee": "費用 (HK$)",
    "ev_session.cha_id": "充電器 ID",
    "ev_session.con_db_id": "連接器 ID",
    "ev_session.meter_start": "電錶開始讀數 (wh)",
    "ev_session.meter_stop": "電表停止讀數 (wh)",
    "ev_session.stop_reason": "停止原因",
    "ev_session.press_start_time": "按壓開始時間",
    "ev_session.start_time": "開始時間",
    "ev_session.press_end_time": "按壓結束時間",
    "ev_session.end_time": "結束時間",
    "ev_session.billing_type": "計費類型",
    "ev_session.status": "狀態",
    "ev_session.soc": "電量狀態",
    "ev_session.cal_fee_at": "計算費用於",
    "ev_session.waiverReason": "免除原因",

    "transaction.category": "類別",
    "transaction.status": "狀態",
    "transaction.payment_vendor": "支付供應商",
    "transaction.payment_method": "付款方式",
    "transaction.total_cost": "總費用 (HK$)",
    "transaction.total_discount": "總折扣 (HK$)",
    "transaction.final_cost": "最終費用 (HK$)",
    "transaction.begin_date": "開始日期",
    "transaction.complete_date": "完成日期",
    "transaction.amount": "金額 (HK$)",
    "transaction.platform": "平台",
    "transaction.info": "交易資訊",
    "transaction.topup": "增值資訊",
    "transaction.ev_session": "充電資訊",

    "transaction_line.trx_line_id": "行 ID",
    "transaction_line.category": "類別",
    "transaction_line.cost": "費用",
    "transaction_line.reference": "參考",

    "report.report_id": "Id",
    "report.report_name": "報表名稱",
    "report.cutoff_date": "截止日期",
    "report.created_at": "建立時間",
    "report.updated_at": "最報更新時間",
    "report.deleted_at": "刪除時間",
    "report.info": "報表內容",
    "report.setting": "設定",
    "report_generated.generated_date": "生成月份",
    "report_generated.status": "狀態",
    "report_time": "報表時間",
    "report_manual_input": "特定支出金額",
    "report_form_edit": "編輯報表",
    "report_form_create": "建立報表",

    "mobile_ads.position": "位置",
    "mobile_ads.external_link": "外部連結",
    "mobile_ads.period": "廣告期間",
    "mobile_ads.start_time": "開始時間",
    "mobile_ads.end_time": "結束時間",


    "ph.name_en": "節日名稱",
    "ph.day": "日期",
    "ph.ph_id": "Id",

    "promotion.promotion_id": "Id",
    "promotion.promotion_name_en": "推廣名稱(英文)",
    "promotion.promotion_name_tc": "推廣名稱(中文)",
    "promotion.promotion_description_en": "推廣簡介 (英文)",
    "promotion.promotion_description_tc": "推廣簡介 (中文)",
    "promotion.start_date": "開始日期",
    "promotion.end_date": "結束日期",
    "promotion.quota": "配額",
    "promotion.method": "方法",
    "promotion.date_period": "日期期間",
    "promotion.coupon_valid_period_day": "優惠卷有效期 (日)",
    "promotion.setting": "規則",
    "promotion.new_setting": "新規則",
    "promotion.topup_amount": "儲值金額",
    "promotion.coupon_amount_setting": "優惠券設定",
    "promotion.coupon_amount": "優惠券金額",
    "promotion.coupon_count": "優惠券數量",
}